<div class="cardVehicle" *ngIf="vehicle!=null">

  <!-- make/model/year -->
  <div *ngIf="MakeModelYearSearch">
    <div class="vehicle-name mb-2">
      <span>{{vehicle.vehicleName}}  </span><!--<small> or similar</small>-->
    </div>
    <div class="vehicle-class ">
      {{vehicle.vehicleClass}}
    </div>
    <div class="car-image">
      <img class="img-fluid" [src]="attachmentService
      .getMMYCarImageLink(vehicle.modelID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.MMYImage,vehicle.makeID,vehicle.modelID,vehicle.year)" [alt]="vehicle.vehicleName" >
    </div>
  <div class="row">
    <div class="col-lg-12  col-md-12 col-12">
      <div class="vehicle-features">
        <div class="row ">
          <!-- vehicle Gear Type-->
          <div class="col-md-6  col-6">
            <div class="d-flex">
              <span><img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' /></span>
              <div>
                <ul *ngFor="let gearType of vehicle.vehicleGearTypeList" class="vehicle-inner-list">
                  <li>{{gearType}}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- vehicle Petrol Type -->
          <div class="col-md-6  col-6">
            <div class="d-flex">
            <span><fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"  [icon]="faGasPump"></fa-icon></span>
              <div>
                <ul *ngFor="let petrolType of vehicle.vehiclePetrolTypeList" class="vehicle-inner-list">
                  <li>{{petrolType}}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- vehicle Passengers Number -->
          <div class="col-md-6  col-6">
           <div class="d-flex">
            <span> <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'PassengersNum' | translate }}" triggers="mouseenter:mouseleave" [icon]="faUser"></fa-icon></span>
            <div>
              <ul *ngFor="let passengersNumber of vehicle.vehiclePassengersNumberList" class="vehicle-inner-list">
                <li>{{passengersNumber}}</li>
              </ul>
            </div>
           </div>
          </div>

          <!-- vehicle Doors Number -->
          <div class="col-md-6  col-6">
            <div class="d-flex">
            <span> <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' /></span>
            <div>
              <ul *ngFor="let doorsNumber of vehicle.vehicleDoorsNumberList" class="vehicle-inner-list">
                <li>{{doorsNumber}}</li>
              </ul>
            </div>
          </div>
          </div>

          <!-- vehicle Storage -->
          <div class="col-md-6  col-6">
            <div class="d-flex">
            <span><mat-icon placement="bottom" ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave" class="fa-s luggage mr-1">luggage</mat-icon></span>
            <div>
              <ul *ngFor="let storage of vehicle.vehicleStorageList" class="vehicle-inner-list">
                <li>{{storage}}</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-6  col-6">
          <div class="d-flex">
            <div class="car-colors  justify-content-center">
              <div class="d-flex">
                <div class="d-flex" style="float: left;" *ngFor="let color of vehicle.vehicleColors; let i = index">
                  <span *ngIf="i < 4">
                    <span class="color-box mr-1 d-flex" [style.backgroundColor]="color.ExtericColor "></span>
                  </span>
                </div>
                <div  *ngFor="let color of vehicle.vehicleColors; let i = index">
                  <span *ngIf="i == 4 && vehicle.vehicleColors.length > 4">
                    <a class="" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample"><i class="far fa-plus-square color-expand"></i></a>
                  </span>
                </div>
              </div>

              <div class="collapse" id="collapseExample">
                <ul>
                  <li class="d-inline" *ngFor="let color of vehicle.vehicleColors; let i = index">

                    <div *ngIf="i > 4">
                      <div class="color-box mr-1" [style.backgroundColor]="color.ExtericColor "></div>
                    </div>
                 
                  </li>
                </ul>
              </div>
             
            </div>
          </div>
          </div>

        </div>
        <div class="row mb-3 mt-1">
          <div class="col-md-12 d-flex location-line "><fa-icon placement="bottom" ngbPopover="{{ 'Location' | translate }}" triggers="mouseenter:mouseleave"  class="mr-1 fa-s map-modal" [icon]="faMapMarkerAlt"></fa-icon>{{vehicle.vehicleLocation}}</div>
        </div>
        <div *ngIf="vehicle.hasPromotion;">
          <div class="promotion-box  mb-3">
            <div class="promotion-icon d-flex align-items-center"><fa-icon class="mr-1 mt-1" [icon]="faTags"></fa-icon> {{vehicle.vehiclePromotionName}}:</div>
            <ul class="mb-0">
              <li *ngFor="let promotion of vehicle.vehiclePromotions">{{promotion}}</li>
            </ul>
          </div>
        </div>
        <policies-icons [policyRequestModel]="vehicle"></policies-icons>

      </div>
    </div>

  </div>
  </div>
  <!-- make/model/year -->

  <!--vehicle view-->
  <div *ngIf="vehicleSearch">
    <div class="vehicle-name mb-2">
          <span>{{vehicle.vehicleName}}  </span><!--<small> or similar</small>-->
      </div>
      <div class="vehicle-class ">
          {{vehicle.vehicleClass}}
      </div>
      <div class="car-image">
          <img class="img-fluid" [src]="attachmentService
          .getImageLink(vehicle.vehicleID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.CarImage)" [alt]="vehicle.vehicleName" >
      </div>

      <div class="row ">
          <!-- vehicle Gear Type-->
          <div class="col-md-6  col-6">
          <div class="d-flex">
          <span><img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' /></span>
          <div>
              <ul class="vehicle-inner-list">
                  <li class="">{{vehicle.vehicleGearType}}</li>
              </ul>
          </div>
          </div>
          </div>

      
          <!-- vehicle Petrol Type -->
          <div class="col-md-6  col-6">
          <div class="d-flex">
          <span><fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave" [icon]="faGasPump"></fa-icon></span>
              <div>
                  <ul  class="vehicle-inner-list">
                  <li>{{vehicle.vehiclePetrolType}}</li>
              </ul>
              </div>
          </div>
          </div>

          <!-- vehicle Condition Unit -->
          <div class="col-md-6  col-6">
          <div class="d-flex">
            <span><mat-icon placement="bottom"  ngbPopover="{{ 'ACUnit' | translate }}" triggers="mouseenter:mouseleave" class="custom-icon mr-1">ac_unit</mat-icon></span>
            <div>
                <ul  class="vehicle-inner-list">
                    <li>{{vehicle.hasAirConditions?'Yes':'No'}}</li>
                </ul>
            </div>
            </div>
            </div>

          <!-- vehicle Passengers Number -->
          <div class="col-md-6  col-6">
          <div class="d-flex">
          <span> <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'PassengersNum' | translate }}" triggers="mouseenter:mouseleave"  [icon]="faUser"></fa-icon></span>
          <div>
              <ul  class="vehicle-inner-list">
                  <li>{{vehicle.vehiclePassengersNumber}}</li>
              </ul>
          </div>
          </div>
          </div>

          <!-- vehicle Doors Number -->
          <div class="col-md-6  col-6">
          <div class="d-flex">
          <span> <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' /></span>
          <div>
              <ul  class="vehicle-inner-list">
                  <li>{{vehicle.vehicleDoorsNumber}}</li>
              </ul>
          </div>
          </div>
          </div>

          <!-- vehicle Storage -->
         <div class="col-md-6  col-6">
          <div class="d-flex">
          <span><mat-icon placement="bottom" placement="bottom" placement="bottom" class="fa-s luggage mr-1" ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave">luggage</mat-icon></span>
          <div>
              <ul  class="vehicle-inner-list">
                  <li>{{vehicle.vehicleStorage}}</li>
              </ul>
          </div>
          </div>
          </div>

          <!-- vehicle Number -->
          <div class="col-md-6  col-6">
          <div class="d-flex">
          <span><fa-icon placement="bottom" ngbPopover="{{ 'PlateNumber' | translate }}" triggers="mouseenter:mouseleave" class="mr-1" [icon]="faCar"></fa-icon></span>
          <div>
              <ul  class="vehicle-inner-list">
                  <li>{{vehicle.plateNumber}}</li>
              </ul>
          </div>
          </div>
          </div>

          <!-- vehicle Odometer -->
          <div class="col-md-6  col-6">
          <div class="d-flex">
          <span><fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'Odometer' | translate }}" triggers="mouseenter:mouseleave" [icon]="faRoad"></fa-icon></span>
          <div>
              <ul  class="vehicle-inner-list">
                  <li>{{vehicle.vehicleOdometer}}</li>
              </ul>
          </div>
          </div>
          </div>


          <div class="col-md-6  col-6">
          <div class="d-flex">
            <div class="car-colors d-flex justify-content-center">
              <ul>
                <li class="d-inline" *ngFor="let color of vehicle.vehicleColors">
                  <div class="color-box mr-1" [style.backgroundColor]="color" ></div>
                </li>
              </ul>
            </div>
          </div>
          </div>

      </div>
      <div class="row mb-3 mt-1">
          <div class="col-md-12 location d-flex "><fa-icon placement="bottom" ngbPopover="{{ 'Location' | translate }}" triggers="mouseenter:mouseleave" class="mr-1 fa-s map-modal" [icon]="faMapMarkerAlt"></fa-icon>{{vehicle.vehicleLocation}}</div>
      </div>
      <div class="vehicle-features">
          <div *ngIf="vehicle.hasPromotion;">
          <div class="promotion-box  mb-3">
              <div class="promotion-icon d-flex align-items-center"><fa-icon class="mr-1 mt-1" [icon]="faTags"></fa-icon> {{vehicle.vehiclePromotionName}}:</div>
              <ul class="mb-0">
              <li *ngFor="let promotion of vehicle.vehiclePromotions">{{promotion}}</li>
              </ul>
          </div>
          </div>
          <policies-icons [policyRequestModel]="vehicle"></policies-icons>
      </div>
  </div>
  <!--vehicle view-->

  <!-- class -->
  <div *ngIf="classSearch">
    <div class="vehicle-class mt-4">
      {{vehicle.vehicleClass}}
    </div>
    <div class="car-image">
      <img class="img-fluid" [src]="attachmentService
      .getImageLink(vehicle.classID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.VehicleClassImg)" [alt]="vehicle.vehicleName" >
    </div>
    <div class="row">
      <div class="col-lg-12 col-md-12 col-lg-12">
        <div class="vehicle-features">
          <div class="row ">
            <!-- vehicle Gear Type-->
           <div class="col-md-6  col-6">
          <div class="d-flex">
                <span><img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' /></span>
                <div>
                  <ul *ngFor="let gearType of vehicle.vehicleGearTypeList" class="vehicle-inner-list">
                    <li>{{gearType}}</li>
                  </ul>
                </div>
            </div>
            </div>


            <!-- vehicle Petrol Type -->
            <div class="col-md-6  col-6">
          <div class="d-flex">
            <span><fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"  [icon]="faGasPump"></fa-icon></span>
                <div>
                  <ul *ngFor="let petrolType of vehicle.vehiclePetrolTypeList" class="vehicle-inner-list">
                    <li>{{petrolType}}</li>
                  </ul>
                </div>
            </div>
            </div>

            <!-- vehicle Passengers Number -->
            <div class="col-md-6  col-6">
              <div class="d-flex">
            <span> <fa-icon placement="bottom" class="mr-1" ngbPopover="{{ 'PassengersNum' | translate }}" triggers="mouseenter:mouseleave" [icon]="faUser"></fa-icon></span>
              <div>
                <ul *ngFor="let passengersNumber of vehicle.vehiclePassengersNumberList" class="vehicle-inner-list">
                  <li>{{passengersNumber}}</li>
                </ul>
              </div>
            </div>
            </div>

            <!-- vehicle Doors Number -->
            <div class="col-md-6  col-6">
              <div class="d-flex">
            <span> <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' /></span>
              <div>
                <ul *ngFor="let doorsNumber of vehicle.vehicleDoorsNumberList" class="vehicle-inner-list">
                  <li>{{doorsNumber}}</li>
                </ul>
              </div>
            </div>
            </div>

            <!-- vehicle Storage -->
            <div class="col-md-6  col-6">
              <div class="d-flex">
            <span><mat-icon placement="bottom" placement="bottom" ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave"  class="fa-s luggage mr-1">luggage</mat-icon></span>
              <div>
                <ul *ngFor="let storage of vehicle.vehicleStorageList" class="vehicle-inner-list">
                  <li>{{storage}}</li>
                </ul>
              </div>
            </div>
            </div>

            <!-- vehicle colors
            <div class="col-lg-6 col-md-6  col-12 d-flex ">
            <div class="car-colors d-flex justify-content-center">
              <ul>
                <li class="d-inline" *ngFor="let color of vehicle.vehicleColors">
                  <div class="color-box mr-1" [style.backgroundColor]="color" ></div>
                </li>
              </ul>
            </div>
            </div> -->

          </div>
          <div class="row mb-3 mt-1">
            <div class="col-md-12 d-flex location-line "><fa-icon placement="bottom" ngbPopover="{{ 'Location' | translate }}" triggers="mouseenter:mouseleave"  class="mr-1 fa-s map-modal" [icon]="faMapMarkerAlt"></fa-icon>{{vehicle.vehicleLocation}}</div>
          </div>
          <div *ngIf="vehicle.hasPromotion;">
            <div class="promotion-box  mb-3">
              <div class="promotion-icon d-flex align-items-center"><fa-icon class="mr-1 mt-1" [icon]="faTags"></fa-icon> {{vehicle.vehiclePromotionName}}:</div>
              <ul class="mb-0">
                <li *ngFor="let promotion of vehicle.vehiclePromotions">{{promotion}}</li>
              </ul>
            </div>
          </div>
          <policies-icons [policyRequestModel]="vehicle"></policies-icons>

        </div>
      </div>
    </div>
  </div>
  <!-- class -->

</div>
